import { Injectable } from '@angular/core';
import { ShowInactiveService } from '../../../base/shared/grid-base/show-inactive.service';
import { IAdaptorService } from '../../../base/shared/syncfusion/adaptor-service.interface';
import {
  AutomaticParkingScheduleClient,
  AutomaticParkingScheduleDTO,
  CreateAutomaticParkingScheduleDTO,
  FilterDTO,
  PagedResultDTOOfAutomaticParkingScheduleDTO,
  SortDirection,
  UpdateAutomaticParkingScheduleDTO,
} from '../../../base/models/models.swagger.generated';
import { Observable, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ErrorType } from '../../../core/routing/error-types';
import { ToastService } from '../../../base/services/toast.service';

@Injectable({
  providedIn: 'root',
})
export class ParkingAdministrationService extends ShowInactiveService implements IAdaptorService {
  public automaticParkingSchedules: AutomaticParkingScheduleDTO[] = [];

  constructor(private automaticParkingScheduleClient: AutomaticParkingScheduleClient,
              private toastService: ToastService) {
    super();
  }

  public getData(skip: number, take: number, filters: FilterDTO[], sortBy: string, sortDirection: SortDirection): Observable<PagedResultDTOOfAutomaticParkingScheduleDTO> {
    if (!sortBy) {
      sortBy = 'Id';
    }
    return this.automaticParkingScheduleClient.searchAutomaticParkingSchedules(filters, skip, take, sortBy, sortDirection).pipe(
      tap((pagedSchedules) => {
       this.automaticParkingSchedules = pagedSchedules.items ?? [];
      })
    );
  }

  public addRecord(data: CreateAutomaticParkingScheduleDTO): Observable<AutomaticParkingScheduleDTO> {
    return this.automaticParkingScheduleClient.createAutomaticParkingSchedule(data)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showApiExeption(error, 'i18n.errors.server-error.title', 'i18n.errors.server-error.message');
          }
          return throwError(() => error);
        }),
      );
  }

  public deleteRecord(id: number): Observable<void> {
    return this.automaticParkingScheduleClient.deleteAutomaticParkingSchedule(id)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showError('i18n.errors.server-error.title', 'i18n.errors.server-error.message', null, ErrorType.serverError);
          }
          return throwError(() => error);
        }),
      );
  }

  public updateRecord(data: UpdateAutomaticParkingScheduleDTO): Observable<AutomaticParkingScheduleDTO> {
    return this.automaticParkingScheduleClient.updateAutomaticParkingSchedule(data)
      .pipe(
        catchError((error: any) => {
          if (!this.toastService.doesErrorExistAlready(ErrorType.serverError)) {
            this.toastService.showApiExeption(error, 'i18n.errors.server-error.title', 'i18n.errors.server-error.message');
          }
          return throwError(() => error);
        }),
      );
  }
}
